<template>

<div>

    <header class="topbar">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <router-link class="navbar-brand" to="/">W3 Website Builder</router-link>
        <ul class="ml-auto navbar-nav" >
          <router-link class="nav-link" href="#" to="/logout">Logout</router-link>
        </ul>
      </nav>
    </header>



  <div class="container">

      <div class="my-3">
        <h1>{{project.name}}</h1> 
        <p class="text-muted"><a :href="'http://'+url(project.slug)" target="_blank">http://{{ url(project.slug) }}</a></p>
        <router-link class="btn btn-primary btn-sm" :to="'/project/'+project.id+'/edit'">Edit</router-link>
      </div>

      <h3>Pages</h3> 
      <table class="table w-75">
        <tbody>
          <tr v-for="page in project.pages">
            <td>{{ page.name }}</td>
            <td>
              <a :href="'http://'+url(project.slug,page.slug)" target="_blank">{{ page.slug }} 
              <svg class="icosvg" viewBox="0 0 24 24">
                <path fill="currentColor" d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z" />
              </svg>
            
            </a></td>
            <td class="text-right"><router-link :to="'/project/'+project.id+'/'+page.id">Edit</router-link></td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-primary" @click="newPage">Add page</button>
   
    </div>
</div>

</template>
<script>

import axios from 'axios';
import Vue from 'vue'

import gHeader from '../components/gHeader.vue'
export default {
  name: 'project',
  components:{'g-header':gHeader},
  // prop:['id'],
  props:['id'],
  data() {
    return {
      project:{},
    }
  },
  methods:{
    url(slug,page){
      var url = slug+'.w3.scaalar.com';
      if(page) url += '/'+page.replace(/\/$/,'')
      return url;
    },
    dataBr(data){
      var d = new Date(data);
      return ('0'+d.getDate()).substr(-2) + '/' +('0'+(d.getMonth()+1)).substr(-2)+'/'+d.getFullYear();
    },

    getProject(){
      axios({
        url: '/api/projects/'+this.id,
      }).then((res) => {
        this.project = res.data;
      });
    },
    newPage(){
      let name = prompt('Page name');

      axios({
        method: 'post',
        url: '/api/pages',
        data: {
          name:name,
          project_id:this.id,
        }
      }).then((res) => {
        this.getProject();
        //router push /project/'+project.id+'/'+page.id
//        let project = res.data;
//        this.editProject(project.id);
      });

    },

  },
  mounted(){
  	console.log('id',this.id);
    this.getProject();
  }

}



</script>

<style>

</style>
